// extracted by mini-css-extract-plugin
export default {"mainContainer":"aSDOTm","questionContainer":"nnWBFJ","nextButton":"DHyhCp"};